import React from 'react';
import './route-list-card.scss';
import { getSelectedItemIds, useAppSelector } from '@zonofi/zono-money-store';
import { SVGS } from '../assets';
import { Avatar, CustomRadio } from '../components';
import { ReactComponent as ArrowRight } from '@zonofi/svg-icons/arrow_right.svg';
import { ReactComponent as Location } from '@zonofi/svg-icons/location.svg';

interface Route {
  id: string;
  name: string;
  numberOfCustomers?: number;
  beatPlanId?: string;
}

interface RouteListCardProps {
  route: Route;
  isFirst?: boolean;
  isLast?: boolean;
  selectionMode?: boolean;
  onClick?: (route: Route) => void;
  onCheckboxToggle?: (route: string) => void;
  selectedIds?: string[];
  showArrowIcon?: boolean;
}

export const RouteListCard: React.FC<RouteListCardProps> = ({
  route,
  isFirst,
  isLast,
  selectionMode,
  onClick,
  onCheckboxToggle,
  selectedIds,
  showArrowIcon = false,
}) => {
  const selectedRouteIds = useAppSelector(getSelectedItemIds);
  const activeSelectedIds = selectedIds ?? selectedRouteIds;
  const isSelected = activeSelectedIds?.includes(route?.id);

  return (
    <div
      className={`route-list-card ${isFirst ? 'first-card' : ''} ${
        isLast ? 'last-card' : ''
      }`}
      onClick={() =>
        selectionMode ? onCheckboxToggle?.(route?.id) : onClick?.(route)
      }
    >
      <div
        className={`route-list-card-content ${
          isLast ? 'last-card-margin' : ''
        }`}
      >
        <Avatar
          profileUrl=""
          id={route?.id}
          size={36}
          style={{ marginRight: '12px' }}
          icon={<Location />}
          iconBgColor="#E5EFFF"
        />

        <div className="route-details">
          <div>
            <div className="route-details-card">
              <span className="route-details-name font-semibold">
                {route?.name}
              </span>
            </div>

            <span className="route-details-phone font-regular">
              <img src={SVGS.UsersIcon} width={11} />
              {`${route?.numberOfCustomers} Customers`}
            </span>
          </div>
          {selectionMode && (
            <CustomRadio
              checked={isSelected}
              customRadioStyles={{
                outerBodyStyle: {
                  width: '20px',
                  height: '20px',
                },
              }}
            />
          )}
          {showArrowIcon && <ArrowRight color="#8C8C8C" width={16} />}
        </div>
      </div>
    </div>
  );
};
